import React from 'react';
import Text from '../../../ui/Text';
import OnboardingList from './OnboardingList';
import * as Styles from './OnboardingStyles';

const Onboarding: React.FC = () => {
  return (
    <Styles.OnboardingContainer>
      <Styles.OnboardingLogin>
        <Styles.OnboardingTitle>
          Comece a dispensar
          <Styles.Highlight> Receitas Digitais </Styles.Highlight>
        </Styles.OnboardingTitle>
        <Text color="white" scale="body1">
          Cerca de 80 mil farmácias em todo o Brasil aceitam receitas digitais da Memed — são mais de 4,7 milhões de
          prescrições por mês.
        </Text>
        <OnboardingList />
      </Styles.OnboardingLogin>
    </Styles.OnboardingContainer>
  );
};

export default Onboarding;
